import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { DischargeReasonApi } from "../Customers/Model/Api/Discharge";
import type { DischargeReason } from "../Customers/Model/Domain/Discharge";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import camelize from "@/Utils/Camelize";

const DischargeReasonTransformer: TransformerExtended<DischargeReason, DischargeReasonApi> = {
  ...DefaultTransformerGenerator<DischargeReason, DischargeReasonApi>(),

  toDomain(input) {
    return camelize<DischargeReasonApi, DischargeReason>(
      input,
      ["i18n", "id", "uuid", "text"],
      ["i18n"]
    ) as DischargeReason;
  },
};

export type DischargeReasonTransformerType = TransformerExtended<DischargeReason, DischargeReasonApi>;

export default DischargeReasonTransformer;
